module.exports = ".container-fluid:first-child {\n  margin-top: 30px; }\n\n.panel-disabled {\n  background: #eee; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/forms/components/form-layout/form-layout.scss
// module id = ./libs/chassis-core/src/app/forms/components/form-layout/form-layout.scss
// module chunks = main